<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  // mounted() {
  //   let getLocalStorage = localStorage.getItem("user");

  //   if (!getLocalStorage) {
  //     // this.$router.push({ path: "/login" });
  //     return true;
  //   } else {
  //     this.$store.commit("SET_USER", JSON.parse(getLocalStorage));
  //     this.$store.commit("SET_TOKEN", localStorage.getItem("token"));
  //   }
  // },
};
</script>
<style >
.swal2-html-container {
  font-family: "Athiti" !important;
}
.swal2-title {
  font-family: "Athiti" !important;
}
.swal2-styled.swal2-confirm {
  font-family: "Athiti" !important;
}

@import url("https://fonts.googleapis.com/css2?family=Athiti:wght@400;500;600&display=swap");

body {
  font-family: "Athiti", sans-serif;
}
</style>
